import { render, staticRenderFns } from "./MarketingCostsList.vue?vue&type=template&id=0894b8ef"
import script from "./MarketingCostsList.vue?vue&type=script&lang=js"
export * from "./MarketingCostsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports